import {
  collection,
  doc,
  setDoc,
  serverTimestamp,
  getDoc,
} from "firebase/firestore";
import { db } from "shared/api/firebase";
import { BrandLanguage, CreateBrandLanguage } from "../type";
import { LanguageDB } from "./Language";

export const createBrandLanguage = async (
  brandId: string,
  language: CreateBrandLanguage,
): Promise<BrandLanguage> => {
  const collectionRef = collection(db, `brands/${brandId}/languages`);
  const docRef = doc(collectionRef);

  await setDoc(docRef, {
    ...language,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  const snapshot = await getDoc(docRef);

  return new LanguageDB(snapshot).toBrandLanguage();
};
